<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    v-if="$vuetify.theme.dark"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.5355 12.4645C21.4882 14.4171 21.4882 17.5829 19.5355 19.5355C17.5829 21.4882 14.4171 21.4882 12.4645 19.5355C10.5118 17.5829 10.5118 14.4171 12.4645 12.4645C14.4171 10.5118 17.5829 10.5118 19.5355 12.4645Z"
      :fill="clr ? clr : '#DFE0E2'"
    />
    <path
      d="M19.5355 12.4645C21.4882 14.4171 21.4882 17.5829 19.5355 19.5355C17.5829 21.4882 14.4171 21.4882 12.4645 19.5355C10.5118 17.5829 10.5118 14.4171 12.4645 12.4645C14.4171 10.5118 17.5829 10.5118 19.5355 12.4645"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 8V6"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 26V24"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.36 9.64L23.07 8.93"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.93003 23.07L9.64003 22.36"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24 16H26"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 16H8"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.36 22.36L23.07 23.07"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.93003 8.93L9.64003 9.64"
      :stroke="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <svg
    v-else
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.99998 8.99996C7.57834 7.54028 7.227 5.34485 8.12211 3.51442C8.17812 3.38116 8.15258 3.22758 8.05647 3.11962C7.96036 3.01165 7.81077 2.96851 7.67192 3.00871C6.60276 3.2843 5.62685 3.84104 4.8455 4.62113C2.42714 6.97709 2.37608 10.8473 4.73145 13.2662C7.15018 15.6218 11.0204 15.5711 13.3765 13.1529C14.1571 12.3721 14.7141 11.3964 14.9897 10.3273C15.0301 10.1882 14.9869 10.0384 14.8787 9.94217C14.7705 9.84598 14.6166 9.82064 14.4833 9.87707C12.6536 10.7718 10.4592 10.4207 8.99998 8.99996Z"
      :fill="clr ? clr : '#DFE0E2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
